import { io, Socket } from 'socket.io-client';

// In production (served by NestJS), connect to same origin. In dev, connect to backend port.
const URL = import.meta.env.VITE_WS_URL
  || (import.meta.env.PROD ? window.location.origin : 'http://localhost:3000');

export const socket: Socket = io(URL, {
  autoConnect: false,
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});
